import { FC, useEffect, useState } from 'react'
import { useDispatch } from 'hooks/useDispatch'
import { useFormBaseError } from 'roadie-ui'

const FormBaseErrorFlashBanner: FC = () => {
  const dispatch = useDispatch()
  const baseError = useFormBaseError()
  const [previousBaseError, setPreviousBaseError] = useState<string | undefined>()

  useEffect(() => {
    if (baseError) {
      if (baseError !== previousBaseError) {
        setPreviousBaseError(baseError)
        dispatch({ type: 'PUSH_FLASH', flash: { type: 'error', message: baseError, id: 'form-flash' } })
      }
    }
  }, [baseError, previousBaseError, dispatch])

  return null
}

export default FormBaseErrorFlashBanner
